import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import EventBus from './utils/event-bus'
import Api from './utils/api'
import Helpers from './utils/helpers'

import FormField from './components/Form/FormField'
import Card from './components/General/Card/Card'

import BootstrapVue from 'bootstrap-vue'
import VTooltip from 'v-tooltip'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import { extendMoment } from 'moment-range'
import Multiselect from 'vue-multiselect'
import VueTheMask from 'vue-the-mask'
import VueSweetalert2 from 'vue-sweetalert2';
import DateRangePicker from 'vitorm11-cj-daterange-picker'
import datePicker from 'vue-bootstrap-datetimepicker';
import VueGoogleCharts from 'vue-google-charts'
import Loading from 'vue-loading-overlay'
import vClickOutside from 'v-click-outside'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import pt_BR from 'vee-validate/dist/locale/pt_BR'
import draggable from 'vuedraggable'
import money from 'v-money'
import Nl2br from 'vue-nl2br'
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import 'reset-css/sass/_reset.scss'
import 'normalize.css/normalize.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import 'pretty-checkbox/dist/pretty-checkbox.css'

import 'vitorm11-cj-daterange-picker/dist/vitorm11-cj-daterange-picker.css'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

import 'vue-loading-overlay/dist/vue-loading.css'

import 'sweetalert2/dist/sweetalert2.min.css'

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.config.productionTip = false;

extendMoment(moment);
momentDurationFormatSetup(moment);
Vue.prototype.moment = moment;
Vue.prototype.moment.locale('pt-BR');
Vue.prototype.eventBus = EventBus;
Vue.prototype.api = Api;
Vue.prototype.helpers = Helpers;
Vue.prototype.sentry = Sentry;

Vue.use(BootstrapVue);
Vue.use(VTooltip);
Vue.use(VueTheMask);
Vue.use(VueSweetalert2);
Vue.use(DateRangePicker);
Vue.use(datePicker);
Vue.use(VueGoogleCharts);
Vue.use(Loading);
Vue.use(vClickOutside);
Vue.use(money, { prefix: 'R$ ', thousands: '.', decimal: ',', masked: true });
Vue.use(PerfectScrollbar);

Vue.component('FormField', FormField);
Vue.component('Card', Card);

Vue.component('multiselect', Multiselect);
Vue.component('DateRangePicker', DateRangePicker);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('Draggable', draggable);
Vue.component('nl2br', Nl2br)

// Validation Rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: pt_BR.messages[rule]
  });
}

if(process.env.VUE_APP_ENVIRONMENT == 'production') {
  Sentry.init({
    dsn: 'https://f6e52c66b6c14eca82fcd96f0c140fe3@sentry.io/5628386',
    integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
    environment: process.env.VUE_APP_ENVIRONMENT,
    release: 'consultaja-dash@'+process.env.VUE_APP_VERSION
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
